<template>
  <modal
    width="35"
    :id="id"
    :show-modal="showModal"
    @close-modal="$emit('close-modal', id)"
  >
    <div class="delete-modal">
      <div class="flex mb-4">
        <h3 class="font-semibold">Tell us why you want to Decline:</h3>
      </div>
      <p>By confirming to decline below, your assigned shipment would be put on hold.</p>
      <div class="my-6">
        <p>Are you sure you want to decline this assigned shipment?</p>
      </div>
      <div>
        <label class="label">Select the reason for cancellation</label>
        <el-select v-model="reason" placeholder="-- Select or Input --">
          <el-option label="Late arrival" value="city.name"> </el-option>
          <el-option label="Damaged package" value="4"> </el-option>
          <el-option label="Rescheduled delivery" value="5"> </el-option>
          <el-option label="Delivery to another address" value="5"> </el-option>
          <el-option label="Others" value="5"> </el-option>
        </el-select>
      </div>

      <label class="label">If others, specify.</label>
      <textarea
        name=""
        id=""
        cols="30"
        rows="10"
        class="input"
        style="height: unset"
      ></textarea>

      <div class="button-wrapper">
        <div class="flex justify-between items-center w-100">
          <p class="cursor-pointer" @click="$emit('close-modal', id)">Go Back</p>
          <base-button
            :loading="loading"
            :disabled="disableAction"
            @click="showDeclineReasonModal = true"
            text="Decline"
          />
        </div>
      </div>
    </div>
    <decline-modal
      :reason="reason"
      :booking="booking"
      @booking-subaction-completed="completedSubmission"
      :show-modal="showDeclineReasonModal"
      @close-modal="showDeclineReasonModal = false"
    />
  </modal>
</template>

<script>
import DeclineModal from "./DeclineModal";

export default {
  components: {
    DeclineModal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disableAction() {
      if (!this.reason.length) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      reason: "",
      loading: false,
      id: "delcine-reason",
      showDeclineReasonModal: false,
    };
  },
  methods: {
    completedSubmission() {
      this.reason = "";
      this.$emit("booking-subaction-completed");
      this.$emit("close-modal", this.id);
    },
  },
};
</script>
